let elementUpdated = false;
let returnUrl: string | null = null;

export const setElementUpdated = (value: boolean) => {
  elementUpdated = value;
};

export const getElementUpdated = () => {
  return elementUpdated;
};

export const setReturnUrl = (value: string | null) => {
  returnUrl = value;
};

export const getReturnUrl = () => {
  return returnUrl;
};
